export default {
    "AF": {
        "name": "Afghanistan"
    },
    "AL": {
        "name": "Albanien"
    },
    "DZ": {
        "name": "Algeriet"
    },
    "AD": {
        "name": "Andorra"
    },
    "AO": {
        "name": "Angola"
    },
    "AG": {
        "name": "Antigua og Barbuda"
    },
    "AR": {
        "name": "Argentina"
    },
    "AM": {
        "name": "Armenien"
    },
    "AU": {
        "name": "Australien"
    },
    "AZ": {
        "name": "Aserbajdsjan"
    },
    "BS": {
        "name": "Bahamas"
    },
    "BH": {
        "name": "Bahrain"
    },
    "BD": {
        "name": "Bangladesh"
    },
    "BB": {
        "name": "Barbados"
    },
    "BE": {
        "name": "Belgien"
    },
    "BZ": {
        "name": "Belize"
    },
    "BJ": {
        "name": "Benin"
    },
    "BT": {
        "name": "Bhutan"
    },
    "BO": {
        "name": "Bolivia"
    },
    "BA": {
        "name": "Bosnien-Hercegovina"
    },
    "BW": {
        "name": "Botswana"
    },
    "BR": {
        "name": "Brasilien"
    },
    "BN": {
        "name": "Brunei"
    },
    "BG": {
        "name": "Bulgarien"
    },
    "BF": {
        "name": "Burkina Faso"
    },
    "MM": {
        "name": "Burma"
    },
    "BI": {
        "name": "Burundi"
    },
    "KH": {
        "name": "Cambodja"
    },
    "CM": {
        "name": "Cameroun"
    },
    "CA": {
        "name": "Canada"
    },
    "CF": {
        "name": "Centralafrikanske Republik"
    },
    "CL": {
        "name": "Chile"
    },
    "CO": {
        "name": "Colombia"
    },
    "KM": {
        "name": "Comorerne"
    },
    "CG": {
        "name": "Congo"
    },
    "CD": {
        "name": "Demokratiske Republik Congo"
    },
    "CR": {
        "name": "Costa Rica"
    },
    "CU": {
        "name": "Cuba"
    },
    "CY": {
        "name": "Cypern"
    },
    "DK": {
        "name": "Danmark"
    },
    "DJ": {
        "name": "Djibouti"
    },
    "DM": {
        "name": "Dominica"
    },
    "DO": {
        "name": "Dominikanske Republik"
    },
    "EC": {
        "name": "Ecuador"
    },
    "EG": {
        "name": "Egypten"
    },
    "CI": {
        "name": "Elfenbenskysten"
    },
    "SV": {
        "name": "El Salvador"
    },
    "ER": {
        "name": "Eritrea"
    },
    "EE": {
        "name": "Estland"
    },
    "ET": {
        "name": "Etiopien"
    },
    "FJ": {
        "name": "Fiji"
    },
    "PH": {
        "name": "Filippinerne"
    },
    "FI": {
        "name": "Finland"
    },
    "AE": {
        "name": "Forenede Arabiske Emirater"
    },
    "FR": {
        "name": "Frankrig"
    },
    "GA": {
        "name": "Gabon"
    },
    "GM": {
        "name": "Gambia"
    },
    "GE": {
        "name": "Georgien"
    },
    "GH": {
        "name": "Ghana"
    },
    "GD": {
        "name": "Grenada"
    },
    "GR": {
        "name": "Grækenland"
    },
    "GT": {
        "name": "Guatemala"
    },
    "GN": {
        "name": "Guinea"
    },
    "GW": {
        "name": "Guinea-Bissau"
    },
    "GY": {
        "name": "Guyana"
    },
    "HT": {
        "name": "Haiti"
    },
    "HN": {
        "name": "Honduras"
    },
    "BY": {
        "name": "Hviderusland"
    },
    "IN": {
        "name": "Indien"
    },
    "ID": {
        "name": "Indonesien"
    },
    "IQ": {
        "name": "Irak"
    },
    "IR": {
        "name": "Iran"
    },
    "IE": {
        "name": "Irland"
    },
    "IS": {
        "name": "Island"
    },
    "IL": {
        "name": "Israel"
    },
    "IT": {
        "name": "Italien"
    },
    "JM": {
        "name": "Jamaica"
    },
    "JP": {
        "name": "Japan"
    },
    "JO": {
        "name": "Jordan"
    },
    "CV": {
        "name": "Kap Verde"
    },
    "KZ": {
        "name": "Kasakhstan"
    },
    "KE": {
        "name": "Kenya"
    },
    "CN": {
        "name": "Kina"
    },
    "KG": {
        "name": "Kirgisistan"
    },
    "KI": {
        "name": "Kiribati"
    },
    "HR": {
        "name": "Kroatien"
    },
    "KW": {
        "name": "Kuwait"
    },
    "LA": {
        "name": "Laos"
    },
    "LV": {
        "name": "Letland"
    },
    "LS": {
        "name": "Lesotho"
    },
    "LB": {
        "name": "Libanon"
    },
    "LR": {
        "name": "Liberia"
    },
    "LY": {
        "name": "Libyen"
    },
    "LI": {
        "name": "Liechtenstein"
    },
    "LT": {
        "name": "Litauen"
    },
    "LU": {
        "name": "Luxembourg"
    },
    "MG": {
        "name": "Madagaskar"
    },
    "MK": {
        "name": "Nordmakedonien"
    },
    "MW": {
        "name": "Malawi"
    },
    "MY": {
        "name": "Malaysia"
    },
    "MV": {
        "name": "Maldiverne"
    },
    "ML": {
        "name": "Mali"
    },
    "MT": {
        "name": "Malta"
    },
    "MA": {
        "name": "Marokko"
    },
    "MH": {
        "name": "Marshalløerne"
    },
    "MR": {
        "name": "Mauretanien"
    },
    "MU": {
        "name": "Mauritius"
    },
    "MX": {
        "name": "Mexico"
    },
    "FM": {
        "name": "Mikronesien"
    },
    "MD": {
        "name": "Moldova"
    },
    "MC": {
        "name": "Monaco"
    },
    "MN": {
        "name": "Mongoliet"
    },
    "ME": {
        "name": "Montenegro"
    },
    "MZ": {
        "name": "Mozambique"
    },
    "NA": {
        "name": "Namibia"
    },
    "NR": {
        "name": "Nauru"
    },
    "NL": {
        "name": "Holland"
    },
    "NP": {
        "name": "Nepal"
    },
    "NZ": {
        "name": "New Zealand"
    },
    "NI": {
        "name": "Nicaragua"
    },
    "NE": {
        "name": "Niger"
    },
    "NG": {
        "name": "Nigeria"
    },
    "KP": {
        "name": "Nordkorea"
    },
    "NO": {
        "name": "Norge"
    },
    "OM": {
        "name": "Oman"
    },
    "PK": {
        "name": "Pakistan"
    },
    "PW": {
        "name": "Palau"
    },
    "PA": {
        "name": "Panama"
    },
    "PG": {
        "name": "Papua Ny Guinea"
    },
    "PY": {
        "name": "Paraguay"
    },
    "PE": {
        "name": "Peru"
    },
    "PL": {
        "name": "Polen"
    },
    "PT": {
        "name": "Portugal"
    },
    "QA": {
        "name": "Qatar"
    },
    "RO": {
        "name": "Rumænien"
    },
    "RU": {
        "name": "Rusland"
    },
    "RW": {
        "name": "Rwanda"
    },
    "KN": {
        "name": "Saint Kitts og Nevis"
    },
    "LC": {
        "name": "Saint Lucia"
    },
    "VC": {
        "name": "Saint Vincent og Grenadinerne"
    },
    "SB": {
        "name": "Salomonøerne"
    },
    "WS": {
        "name": "Samoa"
    },
    "SM": {
        "name": "San Marino"
    },
    "ST": {
        "name": "São Tomé og Príncipe"
    },
    "SA": {
        "name": "Saudi-Arabien"
    },
    "SN": {
        "name": "Senegal"
    },
    "RS": {
        "name": "Serbien"
    },
    "SC": {
        "name": "Seychellerne"
    },
    "SL": {
        "name": "Sierra Leone"
    },
    "SG": {
        "name": "Singapore"
    },
    "SK": {
        "name": "Slovakiet"
    },
    "SI": {
        "name": "Slovenien"
    },
    "SO": {
        "name": "Somalia"
    },
    "ES": {
        "name": "Spanien"
    },
    "LK": {
        "name": "Sri Lanka"
    },
    "GB": {
        "name": "Storbritannien"
    },
    "SD": {
        "name": "Sudan"
    },
    "SR": {
        "name": "Surinam"
    },
    "SE": {
        "name": "Sverige"
    },
    "CH": {
        "name": "Schweiz"
    },
    "SZ": {
        "name": "Swaziland"
    },
    "SY": {
        "name": "Syrien"
    },
    "ZA": {
        "name": "Sydafrika"
    },
    "KR": {
        "name": "Sydkorea"
    },
    "SS": {
        "name": "Sydsudan"
    },
    "TJ": {
        "name": "Tadsjikistan"
    },
    "TZ": {
        "name": "Tanzania"
    },
    "TH": {
        "name": "Thailand"
    },
    "TG": {
        "name": "Togo"
    },
    "TO": {
        "name": "Tonga"
    },
    "TT": {
        "name": "Trinidad og Tobago"
    },
    "TD": {
        "name": "Tchad"
    },
    "CZ": {
        "name": "Tjekkiet"
    },
    "TN": {
        "name": "Tunesien"
    },
    "TR": {
        "name": "Tyrkiet"
    },
    "TM": {
        "name": "Turkmenistan"
    },
    "DE": {
        "name": "Tyskland"
    },
    "TV": {
        "name": "Tuvalu"
    },
    "UG": {
        "name": "Uganda"
    },
    "UA": {
        "name": "Ukraine"
    },
    "HU": {
        "name": "Ungarn"
    },
    "UY": {
        "name": "Uruguay"
    },
    "US": {
        "name": "USA"
    },
    "UZ": {
        "name": "Usbekistan"
    },
    "VU": {
        "name": "Vanuatu"
    },
    "VE": {
        "name": "Venezuela"
    },
    "VN": {
        "name": "Vietnam"
    },
    "YE": {
        "name": "Yemen"
    },
    "ZM": {
        "name": "Zambia"
    },
    "ZW": {
        "name": "Zimbabwe"
    },
    "GQ": {
        "name": "Ækvatorialguinea"
    },
    "AT": {
        "name": "Østrig"
    },
    "TL": {
        "name": "Østtimor"
    }
}